import { HeroUIProvider, ToastProvider } from '@heroui/react';
import { ReactNode } from 'react';
import { useResponsive } from '../hook/useResponsive';

const ToastProviders = ({ children }: { children: ReactNode }) => {
  const isMobile = useResponsive().isMobile;

  return (
    <HeroUIProvider>
      <ToastProvider
        placement={isMobile ? 'top-center' : 'bottom-right'}
        maxVisibleToasts={3}
        toastProps={{
          radius: 'lg',
          color: 'primary',
          variant: 'flat',
          timeout: 4000,
          hideIcon: false,
          classNames: {
            base: [
              'z-9999',
              'bg-background',
              'border border-default-200/50',
              'shadow-lg shadow-black/5',
              'transition-transform duration-200 ease-out',
              'data-[visible=true]:translate-y-0',
            ].join(' '),
            title: 'font-medium text-sm',
            description: 'text-default-600 text-xs',
            closeButton:
              'opacity-70 hover:opacity-100 absolute right-3 top-1/2 -translate-y-1/2 transition-opacity',
            icon: 'w-5 h-5',
          },
        }}
      />
      {children}
    </HeroUIProvider>
  );
};

export default ToastProviders;
